// modules
import { createSelector } from 'reselect'
import { get } from 'lodash'

const medicalDeviceManagement$ = (state = {}) =>
  get(state, ['actions', 'medicalDeviceManagement'], {})

export const medicalDeviceManagementList$ = createSelector(
  medicalDeviceManagement$,
  (medicalDeviceManagement = {}) =>
    get(medicalDeviceManagement, ['medicalDeviceManagementList'], [])
)
